import { useContext } from "react";

import { LangContext } from "../../context/LangContext";
import { useFormatText } from '../../hooks/useFormatText';

import SelectLang from '../../components/SelectLang';

import "./style.css"

function Contact() {
    const formatText = useFormatText();
    const { translations } = useContext(LangContext);

    return (
        <div className='page page_contact'>
            <p className="title_page">
                - <span>Contact</span> -
            </p>

            <SelectLang />

            <div className="sections">
                <section>
                    <span className="subtitle blue">{translations.event_subtitle}</span>

                    <p className="mail_contact">
                        {translations.please_contact_my_event_manager} :
                        <a href="mailto:nathanael.desforges@glenat.com" className="underline">nathanael.desforges@glenat.com</a>
                    </p>

                    <p className="message">
                        <span className="red">{translations.warning} :</span>
                        {translations.any_request_made_without_going_be_automatically_declined}
                    </p>
                </section>

                <i className="dots_line_modile"></i>

                <section>
                    <span className="subtitle blue">{translations.conference_subtitle}</span>

                    <p className="mail_contact">
                        {translations.this_way} ^^ :
                        <a href="mailto:vanrah-tegamiden@outlook.com" className="underline">vanrah-tegamiden@outlook.com</a>
                        <a href="mailto:vanrah-tegamiden@laposte.net" className="underline">vanrah-tegamiden@laposte.net</a>
                    </p>

                    <p className="message">
                        <span className="blue">{translations.tip} :</span>
                        {translations.for_your_first_contact}
                    </p>
                </section>

                <i className="dots_line_modile"></i>
            </div>

            <i className="dots_line_desktop"></i>

            <section className="collaboration">
                <span className="subtitle blue">{translations.collaboration}</span>

                <p className="mail_contact">
                    {translations.this_way_too} *u* :
                    <a href="mailto:vanrah-tegamiden@outlook.com" className="underline">vanrah-tegamiden@outlook.com</a>
                    <a href="mailto:vanrah-tegamiden@laposte.net" className="underline">vanrah-tegamiden@laposte.net</a>
                </p>

                <p className="message">
                    <span className="blue">{translations.tip} :</span>
                    {formatText(translations.for_your_first_contact)}
                </p>

                <p className="message">
                    <span className="red">{translations.warning} :</span>
                    {formatText(translations.my_preferred_genres)}
                </p>

                <p className="message">{formatText(translations.please_note_that)}</p>
            </section>
        </div>
    )
}

export default Contact;